module.exports = __webpack_public_path__ + "static/media/farm.3e0c8440.webp";